<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :meun="meunItem" :title="meunTitle" :title2="headTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <h3 class="title">{{ headTitle }}</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <div class="input_div">
                <p>排序</p>
                <el-input class="input" type="number" onkeyup="value=value.replace(/\D/g,'')" v-model="info.order" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>分类名称</p>
                <el-input class="input" v-model="info.title" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>所属分类</p>
                <el-select class="input" v-model="classify" placeholder="请选择" collapse-tags @change="changeClassify">
                  <el-option v-for="item in classifyOptions" :key="item.id" :value="item.id" :label="item.title"></el-option>
                </el-select>
              </div>
              <div class="input_div">
                <p>状态</p>
                <el-select class="input" v-model="info.status" placeholder="请选择" collapse-tags>
                  <el-option v-for="item in statusOptions" :key="item.en" :value="item.en" :label="item.cn"></el-option>
                </el-select>
              </div>
              <div style="clear: both"></div>
              <div class="input_div" v-show="info.parent_id == 0">
                <p>分类图标</p>
                <input type="file" accept="image/*" style="display: none" id="uploadfile" @change="openFolder" />
                <el-image class="imageDiv" :src="iconImage" fit="scale-down">
                  <div slot="error" class="image-slot" style="position: absolute; top: 50%; left: 50%">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div style="clear: both"></div>
                <el-button size="mini" @click="openImage(true)">{{ iconImage == '' ? '新增' : '更新' }}图标</el-button>
              </div>
            </div>
          </div>
          <!-- <div class="footSubmit">
            <el-button
              style="float: right; margin-right: 30px"
              size="small"
              type="primary"
              @click="saveEdit()"
              >提交</el-button
            >
            <el-button
              style="float: right; margin-right: 15px"
              size="small"
              @click="toCancel()"
              >取消</el-button
            >
          </div> -->
          <FootLayout v-on:saveEdit="saveEdit"></FootLayout>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'
import FootLayout from '@/components/layout/footLayout'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    FootLayout
  },
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      headTitle: '',
      urlPath: URL_PATH,
      info: { order: 10000 },
      statusOptions: [
        { cn: '启用', en: 'Y' },
        { cn: '未启用', en: 'N' }
      ], //是否发布
      classify: '',
      classifyOptions: [], //分类
      iconImage: '' // 分类图标
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.classifyId = this.$route.query.id
      this.headTitle = this.classifyId == null ? '新增分类' : '编辑分类'
      this.getClassify()
    },
    // 获取详情
    getInfo: function () {
      var id = this.$route.query.id
      if (id == null) return
      this.$api
        .shopTypeInfo({
          token: localStorage.getItem('token'),
          id: this.classifyId
        })
        .then(({ data }) => {
          this.info = data.Data
          this.iconImage = this.urlPath + this.info.icon
          this.classifyOptions.forEach(info => {
            if (this.info.parent_id == info.id) {
              this.classify = info.title
            }
          })
        })
        .catch(({ error }) => {})
    },
    // 获取分类
    getClassify: function () {
      this.$api
        .getParentList({
          token: localStorage.getItem('token'),
          id: this.classifyId
        })
        .then(({ data }) => {
          this.classifyOptions = []
          data.Data.forEach(info => {
            this.classifyOptions.push(info)
            if (this.info.parent_id == info.id) {
              this.classify = info.title
            }
          })
          this.getInfo()
        })
        .catch(({ error }) => {})
    },
    // 选择分类
    changeClassify(value) {
      this.info.parent_id = value
    },
    // 新增
    addInfo: function (form) {
      this.$api
        .updateShopType(form)
        .then(({ data }) => {
          this.$router.back(-1)
        })
        .catch(({ error }) => {})
    },
    // 编辑
    updateInfo: function (form) {
      form.append('id', this.info.id)
      this.$api
        .updateShopType(form)
        .then(({ data }) => {
          this.$router.back(-1)
        })
        .catch(({ error }) => {})
    },
    // 选择图片
    openImage() {
      document.getElementById('uploadfile').click()
    },
    openFolder(e) {
      var that = this
      var image = e.target.files[0]
      var reader = new FileReader()
      reader.onload = function (evt) {
        that.iconImage = evt.target.result
      }
      reader.readAsDataURL(image)
      this.info.icon = image
    },
    // 保存
    saveEdit() {
      if (StrUtils.isEmpty(this.info.title) || StrUtils.isEmpty(this.info.parent_id) || StrUtils.isEmpty(this.info.status) || (this.info.parent_id == 0 && StrUtils.isEmpty(this.info.icon))) {
        this.$message.error('请先完善数据')
        return
      }
      var form = new FormData()
      form.append('token', localStorage.getItem('token'))
      form.append('title', this.info.title)
      form.append('order', this.info.order)
      form.append('parent_id', this.info.parent_id)
      form.append('status', this.info.status)
      form.append('icon', this.info.icon)
      if (this.info.id) {
        this.updateInfo(form)
      } else {
        this.addInfo(form)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-top: 24px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.operateText {
  font-size: 14px;
}

.input_div {
  width: 290px;
  margin-right: 120px;
  margin-bottom: 32px;
  float: left;
}
.input_div .input {
  width: 100%;
}
.input_div p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-bottom: 8px;
}
</style>

 <style lang="less">
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type='number'] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
</style>


// WEBPACK FOOTER //
// src/pages/wxapp/enterpriseClassifyAdd.vue